import React from 'react';
import { Toggle, FontIcon, RadioButton } from 'material-ui';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../../generic-components/stepper-actions';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import Dates from './dates';
import moment from 'moment';
import R, { insert, remove, prop, contains, and, toLower, path } from 'ramda';

const checkIfShouldDisable = data => !Boolean(
  data.offerName &&
  data.bookingCode &&
  path(['validDatesOfSale', 0, 'fromDate'], data) &&
  path(['validDatesOfSale', 0, 'toDate'], data) &&
  moment(path(['validDatesOfSale', 0, 'toDate'], data)).isSameOrAfter(path(['validDatesOfSale', 0, 'fromDate'], data)) &&
  path(['validDatesOfTravel', 0, 'fromDate'], data) &&
  path(['validDatesOfTravel', 0, 'toDate'], data) &&
  moment(path(['validDatesOfTravel', 0, 'toDate'], data)).isSameOrAfter(path(['validDatesOfTravel', 0, 'fromDate'], data)) &&
  data.offerDetail
);
const StepOne = ({
  data,
  onTextFieldChangeWithKeyPath,
  goToStep,
  contractingPeriod,
  }) => {
  const shouldDisable = checkIfShouldDisable(data);
  return (
    <div style={{ padding: '24px 12px 0', overflow: 'inherit' }}>
      <TwoColumnRow
        leftColumnStyle={{ position: 'relative', top: '20px', fontSize: '16px', width: '45%' }}
        leftColumnContent={
          <div>
            Please enter a name for your special offer
            <div style={{ fontSize: '12px', color: '#ff4081' }}>* Required</div>
          </div>
        }
        rightColumnStyle={{ width: '48%' }}
        rightColumnContent={
          <TypeControlledTextField
            style={{ width: '100%', position: 'relative', top: '-20px' }}
            value={data.offerName}
            floatingLabelText="Offer Title"
            onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerName'], value })}
          />
        }
      />
      <TwoColumnRow
        leftColumnStyle={{ position: 'relative', top: '10px', fontSize: '16px', width: '45%' }}
        leftColumnContent={
          <div>
            Please enter a booking code that the agent should include at the time of booking.
            <div style={{ fontSize: '12px', color: '#ff4081' }}>* Required</div>
          </div>
        }
        rightColumnStyle={{ width: '48%' }}
        rightColumnContent={
          <TypeControlledTextField
            style={{ width: '100%', position: 'relative', top: '-20px' }}
            value={data.bookingCode}
            floatingLabelText="Booking Code"
            onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'bookingCode'], value })}
          />
        }
      />
      <Dates
        data={data}
        contractingPeriod={contractingPeriod}
        onTextFieldChangeWithKeyPath={onTextFieldChangeWithKeyPath}
      />
      <TwoColumnRow
        outerContainerStyle={{ height: '104px', overflow: '' }}
        leftColumnStyle={{ position: 'relative', top: '10px', fontSize: '16px', width: '45%' }}
        leftColumnContent={
          <div>
            Please note the details of this special offer. For example, when room upgrades are processed (at booking or check-in), buy one get one free, etc.
            <div style={{ fontSize: '12px', color: '#ff4081' }}>* Required</div>
          </div>}
        rightColumnStyle={{ width: '48%', height: '104px', overflowY: 'scroll' }}
        rightColumnContent={
          <TypeControlledTextField
            style={{ width: '100%', position: 'relative', top: '-10px' }} multiLine
            floatingLabelText="Offer Details"
            value={data.offerDetail}
            onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerDetail'], value })}
          />
        }
      />
      <TwoColumnRow
        outerContainerStyle={{ height: '68px', overflow: '' }}
        leftColumnStyle={{ position: 'relative', top: '20px', fontSize: '16px', width: '45%' }}
        leftColumnContent="Please enter any special conditions for this offer, if needed."
        rightColumnStyle={{ width: '48%', height: '84px', overflowY: 'scroll' }}
        rightColumnContent={
          <TypeControlledTextField
            style={{ width: '100%', position: 'relative', top: '-10px' }} multiLine
            floatingLabelText="Special Conditions"
            value={data.specialConditions}
            onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'specialConditions'], value })}
          />
        }
      />
      <TwoColumnRow
        outerContainerStyle={{ height: '68px', overflow: '' }}
        leftColumnStyle={{ position: 'relative', top: '20px', fontSize: '16px', width: '45%' }}
        leftColumnContent="Is this special offer allowed to be combined with other special offers?"
        rightColumnStyle={{ width: '48%', height: '84px' }}
        rightColumnContent={
          <div style={{ position: 'relative', top: '20px' }}>
            <Toggle
              style={{ display: 'inline-block', width: '60px' }}
              toggled={data.allowCombination}
              onToggle={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'allowCombination'], value: !data.allowCombination })}
            />
          </div>}
      />
      <div className="flex-tc-sb">
        <FlatButton
          secondary
          label={'Back'}
          onTouchTap={() => onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: R.omit(['isStayPay', data]) })}
          labelStyle={{ fontWeight: '600' }}
        />
        <FlatButton
          secondary
          label={'Continue'}
          onTouchTap={() => goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 })}
          labelStyle={{ fontWeight: '600' }}
          disabled={shouldDisable}
        />
      </div>
    </div>
  );
};

export default StepOne;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/1-step-offers.jsx